

































import Vue from 'vue';
import Component from 'vue-class-component';

/** The application footer */
@Component
export default class Footer extends Vue {

	links() {
		return this.$t('components.footer.links');
	}

	dividerId(linkId:String) {
		if (linkId != undefined) {
			return 'divider' + linkId;
		}
	}
}
